import { sanitizeImageUrl } from '../imageUrl'
import type { BannerProps } from '../Types'

const SOURCES = [
  { minWidth: 1400, imgWidth: 1920 },
  { minWidth: 1200, imgWidth: 1400 },
  { minWidth: 992,  imgWidth: 1200 },
  { minWidth: 768,  imgWidth: 992  },
  { minWidth: 576,  imgWidth: 768  },
  { minWidth: 360,  imgWidth: 576  },
]

const Banner = ({ title, image, children }: BannerProps) => {
  return (
    <section className="app-hero-img hero-img-has-op-3">
      <picture className="has-object-fit">
        {SOURCES.map(({ minWidth, imgWidth }) => (
          <source
            key={minWidth}
            media={`(min-width: ${minWidth}px)`}
            className="img-fluid desaturate opacity-80"
            srcSet={sanitizeImageUrl(image, { width: imgWidth })}
          />
        ))}
        <img
          data-object-fit="cover"
          className="img-fluid desaturate opacity-80"
          src={sanitizeImageUrl(image, { width: 360 })}
          alt={title}
          title={title}
          fetchPriority="high"
        />
      </picture>

      <div className="hero-img-caption">
        <div className="caption-cell">
          <div className="container-fluid caption-inner caption-inner-offset">
            <h1 className="caption-inner-hero-title">
              <span className="hero-title-location">{title}</span>
            </h1>
            {children}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Banner
